import { Box, Typography, Button, Sheet } from '@mui/joy';
import { Play, ArrowRight } from '@phosphor-icons/react';

/**
 * Карточка «Сегодня»: одна строка + одна кнопка. Что делать прямо сейчас.
 * today: { kind: 'continue'|'start'|'none', title, day, total }
 */
export default function TodayCard({ today, trialDaysLeft, onGo }) {
    const line = today.kind === 'continue'
        ? `${today.title} · день ${today.day} из ${today.total}`
        : today.kind === 'start'
            ? `Начните с дисциплины ${today.title}, день 1`
            : 'План пока не открыт';
    const button = today.kind === 'continue' ? 'Продолжить' : today.kind === 'start' ? 'Начать' : null;

    return (
        <Sheet variant="outlined" sx={{
            p: { xs: 2, sm: 2.5 }, borderRadius: '16px', borderColor: 'divider',
            bgcolor: 'background.surface',
            display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap',
        }}>
            <Box sx={{ flex: 1, minWidth: 220 }}>
                <Typography level="body-xs" sx={{ textTransform: 'uppercase', letterSpacing: '0.08em', fontWeight: 700, color: 'text.tertiary' }}>
                    Сегодня
                </Typography>
                <Typography sx={{ fontSize: { xs: 18, sm: 21 }, fontWeight: 700, letterSpacing: '-0.015em', mt: 0.25 }}>
                    {line}
                </Typography>
                {trialDaysLeft != null && (
                    <Typography level="body-sm" sx={{ color: '#B84C31', fontWeight: 600, mt: 0.5 }}>
                        триал: {trialDaysLeft} дн.
                    </Typography>
                )}
            </Box>
            {button && (
                <Button size="lg" onClick={onGo} endDecorator={today.kind === 'continue' ? <ArrowRight size={18} /> : <Play size={18} weight="fill" />}
                    sx={{ bgcolor: '#37352F', color: '#fff', fontWeight: 700, borderRadius: '10px', px: 3, '&:hover': { bgcolor: '#1F1F1F' } }}>
                    {button}
                </Button>
            )}
        </Sheet>
    );
}
